<app-nav-menu></app-nav-menu>
<dx-load-panel [(visible)]="isLoadPanelVisible"> </dx-load-panel>
<p-dialog header="Booking Details" [style]="{width: '60vw'}" [draggable]="false" [resizable]="false" [dismissableMask]="true" [modal]="true" [(visible)]="popupDepdetails">

  <div style="display:flex;width:100%;flex-direction:column">
    <div class="flight-card" style="margin-bottom: 8px; width: 100%; max-width: 100% !important;padding:7px;display:flex;">
      <div style="display: flex; gap: 20px; justify-content: center; font-size: 12px; align-items: center; width:80%">
        <div style="font-weight:bold">Status:<span style="color:var(--first-color-second)">{{offlineObj.bookingStatusName}}</span> </div>
        <div style="font-weight:bold">Requesting Agency:<span style="color:var(--first-color-second)"> {{offlineObj.requestingAgency}}</span></div>
        <div style="font-weight:bold">Requester Name:<span style="color:var(--first-color-second)">{{offlineObj.requestingUserName}}</span> </div>
        <div style="font-weight:bold">Booking Id: <span style="color:var(--first-color-second)">{{offlineObj.offlineId}}</span></div>

      </div>
      <div style="width:15%">
        <button class="button-42" (click)="MoveToChat()">Move To Chat Now</button>
      </div>

    </div>
    @if (offlineObj.offlineRequestType==16) {
      <div class="flight-card" style="margin-bottom: 8px">
        <span style="padding: 10px; font-weight: bold; display: flex; width: 100%; justify-content: center;padding-top:0px"> Previous Flight Information</span>
        <div class="row m-0">
          <div class="col-md-4 p-0 business" style="display:flex;flex-direction:column">
            <span style="font-size:12px;font-weight:bold">Ticket NO</span>
            <span style="font-size:11px;">{{offlineObj.reissueObj.previousTicketNo}}</span>
          </div>
          <div class="col-md-4 p-0 business" style="display:flex;flex-direction:column">
            <span style="font-size:12px;font-weight:bold">PNR</span>
            <span style="font-size:11px;">{{offlineObj.reissueObj.pnr}}</span>
          </div>
          <div class="col-md-4 p-0 business" style="display:flex;flex-direction:column">
            <span style="font-size:12px;font-weight:bold">Departure Date</span>
            <span style="font-size:11px;">{{offlineObj.reissueObj.departureDate}}</span>
          </div>
        </div>
      </div>
    }

    @if (offlineObj.offlineRequestType==3 || offlineObj.offlineRequestType==16) {
      <div class="flight-card">
        <div class="departure-container">
          <div class="departure-label">{{offlineObj.tripType}}</div>
          <!--<div class="departure-date">26 Jun 2023</div>-->
        </div>
        <div class="header">
          <!--<div class="airline-info">
          <img src="https://via.placeholder.com/40" alt="Avianca Logo" class="airline-logo">
          <div>
            <h3 class="flight-number">AV 121</h3>
            <p class="airline-name">Avianca</p>
          </div>
        </div>-->
        <div class="extras">
          <div style="font-size:10px;display:flex;flex-direction:column;">
            <div style="font-size:12px;font-weight:bold">Criteria Filter</div>
            <div> @if (offlineObj.isLcc) {
              <span style="color:green">✔️</span>
              } @if (!offlineObj.isLcc) {
              <span style="color:red">✖️</span>
            }Low cost</div>
            <div> @if (offlineObj.isGds) {
              <span style="color:green">✔️</span>
              } @if (!offlineObj.isGds) {
              <span style="color:red">✖️</span>
            }GDS</div>
            <div> @if (offlineObj.isNearByAirport) {
              <span style="color:green">✔️</span>
              } @if (!offlineObj.isNearByAirport) {
              <span style="color:red">✖️</span>
            }NearBy Airport</div>
            <div> @if (offlineObj.isDirect) {
              <span style="color:green">✔️</span>
              } @if (!offlineObj.isDirect) {
              <span style="color:red">✖️</span>
            }Direct</div>
          </div>
          <div class="business" style="display:flex;flex-direction:column">
            <span style="font-size:12px;font-weight:bold">Fare Type</span>
            <span style="font-size:11px;">{{offlineObj.fareType}}</span>
          </div>
          <div class="business" style="display:flex;flex-direction:column">
            <span style="font-size:12px;font-weight:bold">Cabin Class</span>
            <span style="font-size:11px;">{{offlineObj.cabinClass}}</span>
          </div>
          <div class="bags" style="display:flex;flex-direction:column">
            <div style="font-size:12px;font-weight:bold">
              Passengers:
            </div>
            <div style="font-size:11px;">
              {{offlineObj.adult}} Adult
            </div>
            <div style="font-size:11px;">
              {{offlineObj.child}} Child
            </div>
            <div style="font-size:11px;">
              {{offlineObj.infant}} Infant
            </div>
          </div>
          <div class="bags" style="display:flex;flex-direction:column">
            <div style="font-size:12px;font-weight:bold">
              Preffered Airlines:
            </div>
            @for (pref of offlineObj.prefferedAirlines; track pref) {
              <div style="font-size:11px;">
                {{pref}}
              </div>
            }
          </div>
        </div>
      </div>
      @for (sec of offlineObj.sectorInfo; track sec; let i = $index) {
        <div class="flight-details">
          <div class="flight-time">
            <p class="time">{{sec.fromCity}}</p>
            <p class="airport">{{sec.fromAirport}}</p>
            <p class="date">{{sec.departureDate | date:'y MMM d'  }}</p>
          </div>
          <div class="flight-duration">
            <div class="animation-container">
              <div class="airplane">✈️</div>
              <div class="dashed-line"></div>
            </div>
            <!--<p class="duration">10h 10m</p>-->
          </div>
          <div class="flight-time">
            <p class="time">{{sec.toCity}}</p>
            <p class="airport">{{sec.toAirport}}</p>
            <p class="date">{{sec.departureDate | date:'y MMM d'}}</p>
          </div>
        </div>
      }
    </div>
  }
  @if (offlineObj.offlineRequestType==5 || offlineObj.offlineRequestType==4) {
    <div class="flight-card">
      <div class="row m-0">
        <div class="col-md-6 p-0">
          <div class="departure-container">
            @if (offlineObj.offlineRequestType==5) {
              <div class="departure-label">Offline Refund</div>
            }
            @if (offlineObj.offlineRequestType==4) {
              <div class="departure-label">Offline Void</div>
            }
          </div>
        </div>
      </div>
      <div class="row m-0 p-0">
        <div class="col-md-4 p-0">
          <div style="display:flex;flex-direction:column">
            <div>
              <span style="font-weight:bold;font-size:12px;color:#ffaa00">Booking Source</span>
            </div>
            <div style="font-size:11px">
              {{offlineObj.bookingSource}}
            </div>
          </div>
        </div>
        <div class="col-md-4 p-0">
          <div style="display:flex;flex-direction:column">
            <div>
              <span style="font-weight:bold;font-size:12px;color:#ffaa00">PNR</span>
            </div>
            <div style="font-size:11px">
              {{offlineObj.pnr}}
            </div>
          </div>
        </div>
        @if (offlineObj.offlineRequestType==5) {
          <div class="col-md-4 p-0">
            <div style="display:flex;flex-direction:column">
              <div>
                <span style="font-weight:bold;font-size:12px;color:#ffaa00">Refund Type</span>
              </div>
              <div style="font-size:11px">
                {{offlineObj.refundType}}
              </div>
            </div>
          </div>
        }
      </div>
      <div class="row m-0 p-0">
        <div class="col-md-12 p-0 justify-content-center">
          <span style="font-weight:bold;font-size:13px;color:black">Travel Information</span>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Ticket No</th>
            </tr>
          </thead>
          <tbody>
            @for (passenger of offlineObj.passengerList; track passenger; let u = $index) {
              <tr>
                <td>{{passenger.ticketNo}}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

</div>
</p-dialog>
<main class="main">
  <ng-template #confirmationModal let-modal>
    <div class="ticketConfirmationModelMain">
      <i class="fas fa-times ticketConfirmationPopupClose" aria-hidden="true" (click)="modal.close()"></i>
      <div class="ticketConfirmationModelInner">
        <div style="
            text-align: center;
            font-style: italic;
            font-size: 18px;
            margin-bottom: 25px;
          ">
          Do You Want to Issue Ticket Online or Offline?
        </div>
        <div style="display: flex; justify-content: center; width: 100%">
          <button class="onlineTicketIssue_btn"
            id="onlineTicketIssue_btn"
            (click)="IssueTicketRequestOnline()">
            Issue Online
          </button>
          <button class="offlineTicketIssue_btn"
            id="offlineTicketIssue_btn"
            style="margin-left: 30px"
            (click)="IssueTicketRequestOffline()">
            Issue Offline
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="cms_main">
    <div class="cms_card">
      <div class="row-card">
        <div class="cms_card-heading">Manager's Request List</div>
        <span class="alert alert-danger hidden-marker"
        id="inprogresstag"></span>
        <!--<div class="col-md-3">
        <ng-select [items]="requestTypeList$ | async"
          bindLabel="requestTypeName" bindValue="requestTypeId"
          [searchable]="true"
          class="OfflineRequestListManagerClass"
          [ngModelOptions]="{standalone: true}"
          placeholder="Select Request Type"
          [(ngModel)]="requestTypeId"
          (change)="OnRequestTypeChange(requestTypeId)"
          >
        </ng-select>
        <label class="label-ticket-req">Select Request Type</label>
      </div>-->
      <!--<i class="uil uil-plus-circle accor_icon" (click)="AddNewRequest()"></i>-->
    </div>
    <div class="row cms_tabel">
      <!--<dx-data-grid [dataSource]="requestList"
      [showBorders]="true"
      [showRowLines]="true"
      [allowColumnResizing]="true"
      (onContentReady)="contentReady($event)">

      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxi-column [visible]="false" caption="Offline Booking Id" dataField="offlineBookingId"></dxi-column>
      <dxi-column alignment="center" caption="Date" dataField="date" dataType="Date"></dxi-column>-->
      <!--<dxi-column alignment="center" caption="Type" dataField="type" dataType="string"></dxi-column>-->
      <!--<dxi-column alignment="center" caption="Pass Name" dataField="passName" dataType="string"></dxi-column>
      <dxi-column alignment="center" caption="PNR" dataField="pnr" dataType="string"></dxi-column>
      <dxi-column alignment="center" caption="Ticket No" dataField="ticketNo" dataType="string"></dxi-column>
      <dxi-column alignment="center" caption="Route" dataField="sector" dataType="string"></dxi-column>
      <dxi-column alignment="center" caption="Airline" dataField="airline" dataType="string"></dxi-column>-->
      <!--<dxi-column alignmnet="center" caption="No of Pass" dataField="noOfPass" dataType="number"></dxi-column>-->
      <!--<dxi-column [visible]="false" alignment="center" caption="Tax" dataField="amount" dataType="number"></dxi-column>
      <dxi-column [visible]="false" alignment="center" caption="Base Fare" dataField="baseFare" dataType="number"></dxi-column>
      <dxi-column [visible]="false" alignment="center" caption="Service Charges" dataField="serviceCharges" dataType="number"></dxi-column>
      <dxi-column alignment="center" caption="Net Amount" dataField="totalNetAmount" dataType="number"></dxi-column>
      <dxi-column alignment="center" caption="Status" dataField="status" dataType="string"></dxi-column>
      <dxi-column caption="Action" type="buttons" [width]="60">
        <dxi-button hint="Edit"
          icon="edit"
        [onClick]="onClickEditRequest"></dxi-button>
      </dxi-column>

      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-paging [pageSize]="10"></dxo-paging>
      <dxo-pager [showPageSizeSelector]="true"
      [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>



    </dx-data-grid>-->

    <p-tabs [value]="selectedTabIndex">
      <p-tablist>
        @for (requestType of filteredData | keyvalue; track requestType; let i = $index) {
          <p-tab [value]="i" (click)="onTabSelected({ index: i })">{{ requestType.key }}</p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        @for (requestType of filteredData | keyvalue; track requestType; let i = $index) {
          <p-tabpanel [value]="i">
          <div >
            <div class="row m-0">
              <div class="col-md-3 col-sm-6 mb-4" style="position: relative;">
                <label id="namelabel" class="labelofmodifyserachinputs">
                  Search by Booking Number
                </label>
                <input type="text" [(ngModel)]="bookingNewChatId" (keyup.enter)="searchBookingNew()"
                  class="inputStyle" required autocomplete="off"
                  name="Name" />
                </div>
                <div>
                  <button class="button-42" style="height:41px;width:93px;background:var(--first-color-second)" (click)="searchBookingNew()">Search</button>
                </div>
              </div>
            </div>
            <dx-data-grid #dataGridRequestList
              [dataSource]="filteredData[requestType.key]"
              [showBorders]="true"
              [showRowLines]="true"
              [allowColumnResizing]="true"
              (onCellPrepared)="onCellPrepared($event)"
              (onContentReady)="contentReady($event)">
              <dxo-filter-row [visible]="true"></dxo-filter-row>
              <dxi-column [visible]="false"
                alignment="center"
                caption="Request Type Id"
                dataField="requestType"
              dataType="string"></dxi-column>
              <dxi-column [width]="200"
                caption="Request Type"
                dataField="requestTypeName"
              dataType="string"></dxi-column>
              <dxi-column alignment="center"
                caption="Request Time"
                dataField="creationDate"
              dataType="string"></dxi-column>
              <dxi-column alignment="center"
                caption="Pnr"
                dataField="pnr"
              dataType="string"></dxi-column>
              <dxi-column alignment="center"
                caption="Trip"
                dataField="sector"
              dataType="string"></dxi-column>
              <dxi-column alignment="center"
                caption="Booking Id"
              dataField="bookingAgencyId"></dxi-column>
              <dxi-column alignment="center"
                caption="Ticket No"
                dataField="tktNo"
              dataType="string"></dxi-column>
              <!--<dxi-column [allowFiltering]="true"
              alignment="center"
              caption="Travel date"
              dataField="travelDate"
              dataType="Date"
            format="dd-MM-yyyy"></dxi-column>-->
            <!--<dxi-column alignment="center"
            caption="Passenger Name"
            dataField="passName"
          dataType="string"></dxi-column>-->
          <dxi-column [visible]="false"
            alignment="center"
            caption="Booking Id"
          dataField="offlineBookingId"></dxi-column>
          <dxi-column [visible]="false"
            alignment="center"
            dataField="agencyId"
          dataType="string"></dxi-column>
          <dxi-column [visible]="false"
            alignment="center"
            dataField="currentBookingStatus"
          dataType="number"></dxi-column>
          <dxi-column [allowFiltering]="true"
            alignment="center"
            caption="Status"
            dataField="status"
          dataType="string"></dxi-column>
          <dxi-column caption="Action" type="buttons" [width]="60">
            <dxi-button hint="Edit"
              icon="edit"
            [onClick]="onClickEditRequest"></dxi-button>
          </dxi-column>
          <dxo-search-panel [visible]="true"></dxo-search-panel>
          <dxo-paging [pageSize]="25"></dxo-paging>
          <dxo-pager [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
        </dx-data-grid>
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
</div>
</div>
</div>
</main>
